import React from 'react';
import { graphql } from 'gatsby';
import { Form as FormComponent } from '../../forms/Form';

export const Form = ({ data, ...rest }) => <FormComponent {...data} {...rest} />;

export const FormQuery = graphql`
  fragment Form on KFH_UmbracoFormComponentType {
    formType
  }
`;
